import {
  AddToPostalCodeWaitingListRequest,
  EditPostalCodeWaitingListRequest,
  PostalCodeWaitingListFindOneResponse,
} from "@shared/dtos/requests/postalCodeWaitingListRequests.dto"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const addToPostalCodeWaitingList = async (data: AddToPostalCodeWaitingListRequest): Promise<void> => {
  await axiosPublic({
    url: "public/postal-code/waitinglist",
    method: "post",
    data,
  })
}

export const verifyEmail = async (hash: string): Promise<void> => {
  await axiosPublic({
    url: `public/postal-code/waitinglist/verify/${encodeURIComponent(hash)}`,
    method: "post",
  })
}

export const findOne = async (hash: string, postalCode: string): Promise<PostalCodeWaitingListFindOneResponse> => {
  const { data } = await axiosPublic({
    url: `public/postal-code/waitinglist/settings/${encodeURIComponent(hash)}/${encodeURIComponent(postalCode)}`,
    method: "get",
  })
  return data
}

export const edit = async (hash: string, postalCode: string, data: EditPostalCodeWaitingListRequest): Promise<void> => {
  await axiosPublic({
    url: `public/postal-code/waitinglist/settings/${encodeURIComponent(hash)}/${encodeURIComponent(postalCode)}`,
    method: "patch",
    data,
  })
}

/**
 * Unsubscribes a user from postal code waiting list notifications.
 */
export const unsubscribe = async (hash: string, postalCode: string): Promise<void> => {
  await axiosPublic({
    url: `public/postal-code/waitinglist/unsubscribe/${encodeURIComponent(hash)}/${encodeURIComponent(postalCode)}`,
    method: "delete",
  })
}
